// extracted by mini-css-extract-plugin
export default {"fs":"f63399a4f8 _34e28181f4"};